//useFetchInternal

import { useDispatch } from "react-redux";
import { useState, useEffect } from "react";
import { setPageData } from "../slices/internalPageSlice";
import { getAPI } from "../API/ApiService";

export default function useFetchInternal(path, slug) {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true); // don’t show loader if we already have data
  const [nodata, setNodata] = useState(false);
  const fetchData = async () => {
    setLoading(true);
    setNodata(false);
    try {
      const response = await getAPI(path);
      if (response?.status === 200) {
        dispatch(setPageData({ slug, data: response?.data }));
      }
      if (response?.status === 500) {
        setNodata(true);
      }
    } catch (error) {
      console.error("Failed to fetch data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [path, slug]);

  return { loading, nodata };
}
